import {omit} from 'underscore';

export default class RideScheduleStop {
  /* eslint-disable camelcase */
  constructor({
    timestamp,
    interim_stop_count,
  }) {
    this.timestamp = timestamp;
    this.interim_stop_count = interim_stop_count;
  }
  /* eslint-enable camelcase */

  get isNext() {
    return this.interim_stop_count === 0;
  }

  clone() {
    return new RideScheduleStop(this.serialize());
  }

  serialize() {
    return omit({
      timestamp: this.timestamp,
      interim_stop_count: this.interim_stop_count,
    }, value => value === null);
  }
}



// WEBPACK FOOTER //
// ./src/common/types/RideScheduleStop.js